
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oferta/[[...offerSlug]]",
      function () {
        return require("private-next-pages/oferta/[[...offerSlug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oferta/[[...offerSlug]]"])
      });
    }
  